import React, { useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav'
import NavBar from '../components/NavBar'
import { Icon } from 'react-icons-kit'
import { ic_work } from 'react-icons-kit/md/ic_work'
import { ic_directions_walk } from 'react-icons-kit/md/ic_directions_walk'
import { ic_person } from 'react-icons-kit/md/ic_person'
import { ic_file_present } from 'react-icons-kit/md/ic_file_present'
import { ic_file_copy_outline } from 'react-icons-kit/md/ic_file_copy_outline'
import { ic_person_pin_outline } from 'react-icons-kit/md/ic_person_pin_outline'
import { coinDollar } from 'react-icons-kit/icomoon/coinDollar'
import { ic_group } from 'react-icons-kit/md/ic_group'
import { handshakeO } from 'react-icons-kit/fa/handshakeO'
import { ic_file_download } from 'react-icons-kit/md/ic_file_download'
import { umbrella } from 'react-icons-kit/fa/umbrella'
import Tooltip from '@material-ui/core/Tooltip'
import { fileText } from 'react-icons-kit/icomoon/fileText'

import api from '../services/api'

import UserOptions from '../components/UserOptions'

import './styles/Home.css';
import FooterDelphus from '../components/FooterDelphus';
import { folderDownload } from 'react-icons-kit/icomoon/folderDownload';
import { OpenInBrowser } from '@material-ui/icons';

function openWindow() {
  let url = api.backendUrl + '/static/' + 'TermoAdesao.pdf'
  window.open(url)
}

function openCondGerais() {

  let url = api.backendUrl + '/static/' + 'KSA_CondicoesGerais.rar'
  window.open(url)
}


function Home() {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [tipoGrupo, setTipoGrupo] = useState('')

  useEffect(() => {
    const fetchData = async () => {

      setTipoGrupo(await api.getTipoGrupo(auth.user))
      console.log(tipoGrupo)

    }

    fetchData()
  }, [])

  return (
    <div className="Home">
      <NavBar />
      <div className="HomeContent">
        <div className="defaultHeader">
          <h1>Seja bem vindo(a), <strong>{auth.name}</strong>.</h1>
          <UserOptions />
        </div>
        <br />
        <div className="atalhos">

          {['M', 'V', 'R', 'P'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href="/sistema/propostas" className="atalho">
                <Icon icon={ic_work} size={40} />
                <strong>{'Propostas'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href="/sistema/usuarios" className="atalho">
                <Icon icon={ic_person} size={40} />
                <strong>{'Usuários'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M', 'A'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href="/sistema/propostaAssociado" className="atalho">
                <Icon icon={ic_file_copy_outline} size={40} />
                <strong>{'Proposta Associado'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          <Tooltip title="Segure Ctrl para abrir em nova aba">
            <Nav.Link href="/sistema/financeiro" className="atalho">
              <Icon icon={coinDollar} size={40} />
              <strong>{'Financeiro'}</strong>
            </Nav.Link>
          </Tooltip>

          {['M', 'A'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href="/sistema/coberturas" className="atalho">
                <Icon icon={umbrella} size={40} />
                <strong>{'Coberturas'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M', 'A'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href="/sistema/coberturas/cadastro" className="atalho">
                <Icon icon={ic_person_pin_outline} size={40} />
                <strong>{'Informações Cadastrais - Associado'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M', 'P', 'R', 'V'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href="/sistema/parceiro_venda" className="atalho">
                <Icon icon={handshakeO} size={40} />
                <strong>{'Informações Cadastrais - Parceiro'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M', 'A', 'P'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href='sistema/home' className="atalho" onClick={openWindow}>
                <Icon icon={ic_file_present} size={40} />
                <strong>{'Termo de Adesão'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M', 'A', 'P'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href='sistema/home' className="atalho" onClick={openCondGerais}>
                <Icon icon={ic_file_download} size={40} />
                <strong>{'Condições Gerais'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M'].indexOf(tipoGrupo) >= 0 ?
            <Tooltip title="Segure Ctrl para abrir em nova aba">
              <Nav.Link href="/sistema/grupo_usuarios" className="atalho">
                <Icon icon={ic_group} size={40} />
                <strong>{'Grupo de Usuários'}</strong>
              </Nav.Link>
            </Tooltip> : (<></>)}

          {['M', 'P'].indexOf(tipoGrupo) >= 0 ? <Tooltip title="Segure Ctrl para abrir em nova aba">
            <Nav.Link href="/sistema/vendedores" className="atalho">
              <Icon icon={ic_directions_walk} size={40} />
              <strong>{'Vendedores'}</strong>
            </Nav.Link>
          </Tooltip> : (<></>)}


          {['P'].indexOf(tipoGrupo) >= 0 ? <Tooltip title="Segure Ctrl para abrir em nova aba">

            <Nav.Link href="/sistema/RelatorioComissoes" className="atalho">
              <Icon icon={fileText} size={22} />
              <strong>{'Relatório Comissionamento'}</strong>
            </Nav.Link>
          </Tooltip> : (<></>)}

        </div>
        <div className="HomeOptions">
          {/* <FrCollapsibleMenu/> */}
        </div>
        <FooterDelphus />
      </div>
    </div >
  );
}

export default Home;
